( function () {
	'use strict';

	function reportDropdown ( $document, $filter, _, $timeout, moment ) {
		function link ( scope, element ) {
			function hidePopElement () {
				$document.off( 'click' );
				angular.element( element ).find( '.popup-select' ).addClass( 'hidden' );
			}

			function hideElement ( isActive ) {
				if ( isActive ) {
					return $document.off( 'click' );
				}
				$document.on( 'click', function ( event ) {
					if ( !element.is( event.currentTarget ) ) {
						hidePopElement();
						scope.searchItem = '';
						return scope.$apply();
					}
				} );
			}

			function showElement () {
				element.on( 'click', function ( event ) {
					var currentEl = angular.element( event.currentTarget ).find( '.popup-select' );

					$document.off( 'click' );
					event.stopPropagation();

					if ( !scope.disable ) {
						angular.element( '.popup-select' ).not( currentEl ).addClass( 'hidden' );
						angular.element( event.currentTarget ).find( '.popup-select' ).removeClass( 'hidden' );

						$timeout( function () {
							angular.element( event.currentTarget ).find( 'input:text' )[ 0 ].focus();
						} );
					}
					hideElement();
				} ).children().find( 'ul' ).on( 'click', function () {
					return false;
				} );
			}

			function search ( row ) {
				if ( !scope.searchItem ) {
					return true;
				}

				var searchItem = _.escapeRegExp( scope.searchItem );
				var pattern    = new RegExp( searchItem, 'gi' );

				return row[ scope.pointer ].match( pattern );
			}

			function resultOption ( data ) {
				scope.selected = data;

				if ( scope.filterFn ) {
					scope.filterFn( scope.selected, scope.parentFilter, scope.childFilter );
				}

				hidePopElement();
			}

			function convertDate ( date ) {
				return moment( date ).format( 'MM/DD/YYYY' );
			}

			function activate () {
				showElement();
				hideElement( true );
			}

			scope.resultOption   = resultOption;
			scope.search         = search;
			scope.hidePopElement = hidePopElement;
			scope.convertDate    = convertDate;

			activate();
		}

		return {
			'templateUrl' : '/templates/report/report-components/report-dropdown/report-dropdown.html',
			'link'        : link,
			'scope'       : {
				'list'         : '=',
				'selected'     : '=',
				'title'        : '@',
				'pointer'      : '@',
				'marker'       : '@',
				'disable'      : '=',
				'filterFn'     : '=',
				'parentFilter' : '@',
				'childFilter'  : '@'
			}
		};
	}

	angular.module( 'app.report' )
		.directive( 'reportDropdown', reportDropdown );
} )( );
